import React from 'react';
import { CheckIcon, CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const productImage = 'https://cdn.magicpatterns.com/uploads/qKNKUhk9aNvSXbimnQRm2Q/Diseno-sin-titulo-2026-07-19T202903.740.webp';
const items = ['6 volumi didattici completi del sistema TENNIS PRONTO', '5 bonus strategici esclusivi', '360+ sessioni pronte all’uso', 'Accesso a vita al materiale digitale', 'PDF alta qualità per Tablet e Stampa'];
export function PricingSection() {
  return <section id="offerta" className="bg-[#f5faee] px-5 py-20" data-id="element-169" data-mp="1s8c3q0dt8lc5">
      <div className="mx-auto max-w-xl text-center" data-id="element-170" data-mp="1x8zuqm21h26d">
        <p className="inline-block bg-[#102016] px-4 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-171" data-mp="1x9hx80faocmq">
          Offerta speciale di lancio
        </p>
        <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-none text-[#102016] sm:text-5xl" data-id="element-172" data-mp="2vh29qmv89rx">
          Tutto incluso,{' '}
          <span className="text-emerald-700" data-id="element-173" data-mp="7vwbc6046v43">un unico prezzo.</span>
        </h2>
        <p className="mt-3 text-sm font-semibold text-slate-600" data-id="element-174" data-mp="1mi98qzg66qho">
          Nessun abbonamento. Nessuna sorpresa.
        </p>
        <article className="mt-10 overflow-hidden border border-emerald-950/10 bg-white text-center shadow-xl" data-id="element-175" data-mp="1hnvckutoofby">
          <header className="border-t-4 border-emerald-500 bg-[#102016] px-6 py-7" data-id="element-176" data-mp="17rs9nmr0ccny">
            <h3 className="font-display text-3xl font-bold uppercase text-white" data-id="element-177" data-mp="17ppbugjm5f8o">
              TENNIS PRONTO™ — Pacchetto completo
            </h3>
            <p className="mt-2 text-sm font-semibold text-emerald-300" data-id="element-178" data-mp="20g64xuqpouvt">
              6 Volumi + 5 Bonus Strategici
            </p>
          </header>
          <div className="p-7 sm:p-10" data-id="element-179" data-mp="1vjfpn9mqe3bg">
            <img src={productImage} alt="Pacchetto completo TENNIS PRONTO" width={1024} height={1024} loading="lazy" className="mx-auto -mt-3 mb-3 w-full max-w-md object-contain" data-id="element-180" data-mp="1rgj4pc9pxv4c" />
            <div id="dettagli-offerta" className="mb-8 scroll-mt-3 border-y border-emerald-950/10 py-7" data-id="element-181" data-mp="hhrrat2fepl1">
              <p className="mb-5 text-xs font-bold uppercase tracking-widest text-[#102016]" data-id="element-182" data-mp="mfjnhza3sxv1">
                Cosa include
              </p>
              <ul className="grid gap-3 text-left sm:grid-cols-2" data-id="element-183" data-mp="7lyb8zpi0dyi">
                {items.map(item => <li key={item} className="flex items-center gap-2 text-sm font-semibold text-[#102016]" data-id="element-184" data-mp="3uwo2byf42ovt">
                    <span className="grid h-5 w-5 place-items-center rounded-full bg-emerald-100" data-id="element-185" data-mp="3jbd6h28hwsv">
                      <CheckIcon className="h-3.5 w-3.5 text-emerald-700" data-id="element-186" data-mp="3l0b9t3vayh2n" />
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="mt-7" data-id="element-187" data-mp="3bzwpa6q5x607">
              <p className="text-sm font-semibold text-slate-600" data-id="element-188" data-mp="3fzx2xp5ftd67">
                Valore totale: <s data-id="element-189" data-mp="2xb3fn57f4xl3">€106</s>
              </p>
              <div className="mt-1 flex items-baseline justify-center text-[#102016]" data-id="element-190" data-mp="2xc4snf7zvu5g">
                <span className="font-display text-5xl font-bold" data-id="element-191" data-mp="2scs14h66hywj">€</span>
                <strong className="font-display text-8xl font-bold leading-none tracking-tight" data-id="element-192" data-mp="36bjge6ws1qm9">
                  19
                </strong>
              </div>
              <div className="mt-3 flex flex-wrap justify-center gap-3" data-id="element-193" data-mp="31bdjocbnhdxb">
                <span className="bg-emerald-500 px-3 py-1.5 text-xs font-bold uppercase tracking-widest text-white" data-id="element-194" data-mp="3g8o4ica6nw5p">
                  Risparmi €87
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-slate-600" data-id="element-195" data-mp="3p2spwg6jsfdu">
                  Pagamento unico
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-slate-600" data-id="element-196" data-mp="3l2sbgvjg846s">
                  Accesso a vita
                </span>
              </div>
            </div>
            <a href="https://tennis-pronto.impultienda.ar/checkout" className="cta-button -mx-2 mt-6 block w-[calc(100%+1rem)] rounded-2xl px-6 py-6 text-xl font-bold sm:text-2xl" data-id="element-197" data-mp="3u36yq0fz3tcx">
              SÌ! VOGLIO TENNIS PRONTO
            </a>
            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-slate-600" data-id="element-198" data-mp="qrpdacr6ki3n">
              <ShieldCheckIcon className="h-4 w-4 text-emerald-700" data-id="element-199" data-mp="vozesqrugk7u" />
              Coperto dalla nostra garanzia soddisfatti o rimborsati di 7 giorni
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 border-t border-emerald-950/10 pt-6 text-xs font-bold text-slate-600" data-id="element-200" data-mp="301w4mjq0lek">
              <span className="flex gap-1" data-id="element-201" data-mp="81zme0qjggh0">
                <LockKeyholeIcon className="h-4 w-4" data-id="element-202" data-mp="cz9iu0cchsec" />
                Pagamento sicuro
              </span>
              <span className="flex gap-1" data-id="element-203" data-mp="1je0e9oip8l0z">
                <ZapIcon className="h-4 w-4" data-id="element-204" data-mp="1jh63d3rbvmwp" />
                Accesso immediato
              </span>
              <span className="flex gap-1" data-id="element-205" data-mp="1og96ujrntl2k">
                <CreditCardIcon className="h-4 w-4" data-id="element-206" data-mp="38wgujct8gps5" />
                Carta · Google Pay · Apple Pay
              </span>
            </div>
          </div>
        </article>
        <p className="mt-5 text-xs font-semibold text-slate-600" data-id="element-207" data-mp="2z6e1jcm43btt">
          Prezzo finale in euro, pagamento una tantum e accesso immediato al
          materiale digitale.
        </p>
      </div>
    </section>;
}